import { useMutation } from '@tanstack/react-query'
import { postUserReport, UserReportPayload } from '../../../../apis/userReport'

/**
 * 不具合報告（フォーマットC）送信 Mutation
 */
export const useUserReportMutation = () => {
  return useMutation({
    mutationFn: async (data: UserReportPayload) => postUserReport(data),
  })
}
